<template>
    <div>
        <toolbar></toolbar>
        <sidebar></sidebar>
        <v-fade-transition mode="out-in">
            <router-view />
        </v-fade-transition>
    </div>
</template>
<script>
import Toolbar from './core/Toolbar.vue';
import Sidebar from './core/Sidebar.vue';

export default {
    components:{
        'toolbar': Toolbar,
        'sidebar': Sidebar
    }
}
</script>

<style lang="less">
  
</style>